export interface ICompanyOption {
  inputValue?: string;
  name: string;
  companyKey?: number;
  isExisting?: boolean;
  activeUsers: number;
}

export interface ILocationOption {
  addresskey: number;
  siteName: string | null;
  line1: string | null;
  line2: string | null;
  city: string | null;
  stateProvince: string | null;
  postalcode: string | null;
  country: string;
  phone: string | null;
  latitude: string | null;
  longitude: string | null;
  verified: string | null;
  addressStatusString: string | null;
  siteTypeCode: string;
}

export const newAddressKeyCode = 1;

export const newLocationDefault: ILocationOption = {
  addresskey: newAddressKeyCode,
  siteName: '',
  line1: '',
  line2: '',
  city: '',
  stateProvince: '',
  postalcode: null,
  country: 'USA',
  phone: '',
  latitude: '',
  longitude: '',
  verified: '',
  addressStatusString: '',
  siteTypeCode: ''
};

export interface ICompanySelectionState {
  searchValue: string;
  company: ICompanyOption | null;
  selectedSupplierCompanyKey?: number[];
  locations: [];
  selectLocation: ILocationOption;
  countryOptions: [];
  country: string;
  stateProvinceOptions: [];
  stateProvince: string;
  siteName: string;
  line1: string;
  line2: string;
  city: string;
  postalcode: string;
  phone: string;
  siteTypeCode: string;
  siteTypeCodeOptions: [];
}

const CompanySelectionState: ICompanySelectionState = {
  searchValue: '',
  company: null,
  locations: [],
  selectLocation: newLocationDefault,
  countryOptions: [],
  country: 'USA',
  stateProvinceOptions: [],
  stateProvince: '',
  siteName: '',
  line1: '',
  line2: '',
  city: '',
  postalcode: '',
  phone: '',
  siteTypeCode: '',
  siteTypeCodeOptions: []
};

export default CompanySelectionState;
